<!-- eslint-disable-next-line @angular-eslint/template/no-negated-async -->
@if (!(iframeBannerClosed$ | async)) {
  <div id="iframe-banner">
    <button type="button" id="go-fullscreen" (click)="goFullscreen()">
      <span translate="lti-go-fullscreen" id="fullscreen-btn-label"></span>
      <i class="ficon-app-external-link"></i>
    </button>
    <button type="button" id="banner-close" [attr.aria-label]="'common_close' | translate" (click)="closeBanner()">
      <i class="ficon-app-x"></i>
    </button>
  </div>
}
